import {Component, inject} from '@angular/core';
import {BaseModalComponent} from "../../base-modal/base-modal.component";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {CommonModule} from "@angular/common";
import {MatButton} from "@angular/material/button";
import {RecordData, RecordUpdateRequestData, SelectData} from "../../../../types/records-table.types";
import {defaultRecordData} from "../../../../models/default-record-data";
import {bloggerModalResourceType} from "../configs/blogger-modal-config";
import {DialogData, EditBloggerFormField} from "../types/edit-blogger-modal.types";
import {editBloggerFormFields, editBloggerModalName} from "../configs/edit-blogger-modal-config";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";

@Component({
  selector: 'app-edit-blogger-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatFormField,
    MatInput,
    MatLabel,
    CommonModule,
    ReactiveFormsModule,
    MatButton,
    MatOption,
    MatSelect
  ],
  templateUrl: './edit-blogger-modal.component.html',
  styleUrl: './edit-blogger-modal.component.scss'
})
export class EditBloggerModalComponent extends BaseModalComponent {
  public dialogData = inject<DialogData>(MAT_DIALOG_DATA);

  public formGroup: FormGroup = new FormGroup({});
  public readonly formFields = editBloggerFormFields;

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(editBloggerModalName);
    this.initForm();
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(editBloggerModalName);
  }

  public async handleBloggerUpdate(): Promise<void> {
    const { id = null, ...updatedData } = {
      ...this.dialogData.recordData,
      ...this.formGroup.value
    };

    const updatedRecordData = this.setUpdatedRecordData(updatedData)

    await this.sendRecordUpdate(updatedRecordData);
  }

  public getSelectOptions(key: string): Array<SelectData> | null | undefined {
    return this.getSelectData(key);
  }

  public getSelectedDataColor(key: string): string | null {
    const value = this.formGroup.get(key)?.value;
    if (!value) { return null; }

    const selectedData = this.getSelectData(key)?.find((selectData: SelectData) =>
      selectData.id.toString() == value
    ) ?? null;

    if (!selectedData || !selectedData.color) { return null; }

    return this.utilityService.hexToRgba(selectedData.color, 0.35);
  }

  public getColorWithOpacity(hex: string | null, opacity: number): string {
    if (!hex) { return '#fff'; }

    return this.utilityService.hexToRgba(hex, opacity);
  }

  private initForm(): void {
    const fieldNames: Array<string> = this.formFields.map((field: EditBloggerFormField) => field.fieldName);
    this.formGroup = this.baseModalService.initForm(fieldNames);
    this.formGroup.patchValue(this.dialogData.recordData);
  }

  private setUpdatedRecordData(updatedData: RecordData): RecordUpdateRequestData {
    return {
      recordId: this.dialogData.recordData.id,
      path: bloggerModalResourceType.path,
      ...updatedData
    };
  }

  private getSelectData(key: string): Array<SelectData> | null | undefined {
    return this.dialogData.bloggerPropertiesParams.find(field => field.key === key)?.metaSelectKeyList;
  }

  private async sendRecordUpdate(updatedRecordData: RecordUpdateRequestData): Promise<void> {
    await this.updatedRecordData(updatedRecordData)
      .then(() => this.closeDialog('cancel'))
      .catch(() => defaultRecordData);
  }
}
